import './ReadMoreShowcase.scss';

class ReadMoreShowcase {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['ReadMoreShowcase'] = ReadMoreShowcase;
export default ReadMoreShowcase;
